import List from "./List";
import Item from "./Item";

class UsersList extends List {}

UsersList.type = Item;

module.exports = UsersList;



// WEBPACK FOOTER //
// ./src/js/structs/UsersList.js